// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._20G1T{background:transparent url(/assets/svg/general-error.svg) 100% 0 no-repeat;background-size:600px 408px;margin:0 4rem;padding:4rem 0;position:relative}.yKc0T{background-image:url(/assets/svg/not-found.svg)}._1kp6R{background:#fff;-webkit-box-shadow:0 4px 16px rgba(50,66,121,.1);box-shadow:0 4px 16px rgba(50,66,121,.1);width:65%}._1kp6R p{line-height:1.35}._1kp6R .btn__labelWrapper{padding:0 2rem}._295hD{padding:8rem}._3lxr-{color:#30a8ff;font-weight:700}._2kf7-{font-size:48px;font-size:4.8rem;line-height:1.2;margin-bottom:3rem}", ""]);
// Exports
exports.locals = {
	"error": "_20G1T",
	"error--404": "yKc0T",
	"errorInfo": "_1kp6R",
	"errorInfo__inner": "_295hD",
	"errorInfo__errorCode": "_3lxr-",
	"errorInfo__errorTitle": "_2kf7-"
};
module.exports = exports;
